document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) {
    const menu = document.querySelector('[data-mobile-menu]');
    if (!menu) return;
    const open = menu.hasAttribute('hidden');
    if (open) menu.removeAttribute('hidden'); else menu.setAttribute('hidden', '');
    toggle.setAttribute('aria-expanded', String(open));
  }

  const close = event.target.closest('[data-menu-close]');
  if (close) {
    const menu = document.querySelector('[data-mobile-menu]');
    if (menu) menu.setAttribute('hidden', '');
    const opener = document.querySelector('[data-menu-toggle]');
    if (opener) opener.setAttribute('aria-expanded', 'false');
  }
});

document.addEventListener('change', (event) => {
  if (event.target.matches('[data-variant-select]')) {
    const option = event.target.selectedOptions[0];
    const form = event.target.closest('form');
    const price = form?.closest('[data-product-root]')?.querySelector('[data-product-price]');
    if (price && option?.dataset.price) price.textContent = option.dataset.price;
  }
});


document.addEventListener('change', (event) => {
  if (event.target.matches('[data-card-variant-select]')) {
    const option = event.target.selectedOptions[0];
    const card = event.target.closest('.product-card');
    const price = card?.querySelector('[data-card-price]');
    if (price && option?.dataset.price) {
      price.textContent = option.dataset.price;
    }
  }
});
